import { TOKEN_META_BY_ADDRESS } from 'tools/utils/constants';

import type { TokenInfo } from 'types/api/token';
import type { TokenPriceData } from 'ui/token/useTokenPriceData';

const validPrice = (value: unknown): number | undefined => {
  if (value === null || value === undefined || value === '') {
    return undefined;
  }
  const number = Number(value);
  return Number.isFinite(number) && number >= 0 ? number : undefined;
};

export default function enrichTokenWithMarketData(token: TokenInfo, data?: TokenPriceData, chainlinkPrice?: number) {
  const price = validPrice(chainlinkPrice) ?? validPrice(data?.current_price) ?? validPrice(token.exchange_rate);
  const marketCap = validPrice(data?.market_cap) ?? validPrice(token.circulating_market_cap);
  const metadata = TOKEN_META_BY_ADDRESS[token.address_hash.toLowerCase()];
  const icon = metadata?.logo || token.icon_url || data?.image?.small || data?.image?.thumb || data?.image?.large;

  return {
    token: {
      ...token,
      ...(metadata ? { name: metadata.name, symbol: metadata.symbol } : {}),
      ...(icon ? { icon_url: icon } : {}),
      exchange_rate: price !== undefined ? String(price) : null,
    },
    price,
    marketCap,
  };
}
